const flow = require('lodash/fp/flow');
const merge = require('lodash/merge');
const { format, subMonths, differenceInDays } = require('date-fns');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');

function getQS(parsedMetaData) {
  return {
    pfId: parsedMetaData.portfolio.pfRelId,
    branchCode: parsedMetaData.portfolio.branchCode,
  };
}

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    Accept: 'application/json',
    'Cache-Control': 'max-age=30'
  };
  const reqOpts = { headers, method: 'POST', json: true };

  const requestArray = flow(
    requestHandler,
    x => x.catch(e => {
      if (e.statusCode === 404) return [];
      throw e;
    })
  );

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  function getMaturityDetails(uri, metaData, portfolioId, fromDate, toDate) {
    const url = getUrl(uri);
    const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        pfRelId: parsedMetaData.portfolio.pfRelId, 
        pfId: parsedMetaData.portfolio.pfRelId,
        branchCode: parsedMetaData.portfolio.branchCode,
        destinationCurrency: parsedMetaData.qs.destinationCurrency,
        toDate: toDate,
        fromDate: fromDate
      };

    return requestArray(merge(
      {},
      reqOpts,
      { url, body },
      parsedMetaData
    ));
  }

  return {
    getMaturityBondsDetails(metaData, portfolioId, fromDate, toDate) {
      return getMaturityDetails('maturity-bonds-details', metaData, portfolioId, fromDate, toDate);
    },
    getMaturityDciDetails(metaData, portfolioId, fromDate, toDate) {
      return getMaturityDetails('maturity-dci-details', metaData, portfolioId, fromDate, toDate);
    },
    getMaturityDepositsDetails(metaData, portfolioId, fromDate, toDate) {
      return getMaturityDetails('maturity-deposits-details', metaData, portfolioId, fromDate, toDate);
    },
    getMaturityFxForwardsDetails(metaData, portfolioId, fromDate, toDate) {
      return getMaturityDetails('maturity-fx-forwards-details', metaData, portfolioId, fromDate, toDate);
    },
    getMaturityLoanDetails(metaData, portfolioId, fromDate, toDate) {
      return getMaturityDetails('maturity-loan-details', metaData, portfolioId, fromDate, toDate);
    },
    getMaturityInNextOneYear(metaData) {
      const url = getUrl('maturity-in-next-one-year');
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        pfRelId: parsedMetaData.portfolio.pfRelId, 
        pfId: parsedMetaData.portfolio.pfRelId,
        branchCode: parsedMetaData.portfolio.branchCode,
        destinationCurrency: parsedMetaData.qs.destinationCurrency
      }
      return requestArray(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    }
  };
}

module.exports = apiFactory;
